import { Button } from '@material-ui/core';
import React, { useRef, useState } from 'react';

import './InputMouseAction.scss';

export type InputMouseActionEventProps = {
	handleLocationAttributeChange: (_value: number, _styleProperty: string, _valueProperty?: string) => void;
	handleMouseActionSelectInput: (
		_ref: any,
		_event: any,
		_styleProperty: string,
		_updateCallback: (_updatedValue: number) => void
	) => void;
	handleOnMouseMove?: (_e: React.MouseEvent) => void;
	handleOnMouseUp?: (_e: React.MouseEvent) => void;
};

type InputMouseActionProps = InputMouseActionEventProps & {
	value: number;
	styleProperty: string;
	valueProperty?: string;
};

const getLabelText = (text: string) => {
	return text.substring(0, 1).toUpperCase();
};

const InputMouseAction = ({
	value,
	styleProperty,
	valueProperty,
	handleMouseActionSelectInput,
	handleLocationAttributeChange,
	handleOnMouseMove,
	handleOnMouseUp,
}: InputMouseActionProps) => {
	const ref = useRef<any>(null);
	const inputRef = useRef<any>(null);
	const [inputMode, setInputMode] = useState(false);
	const [isDragging, setIsDragging] = useState(false);

	const roundedValue = Math.round(value * 10) / 10;
	const label = `${valueProperty ? getLabelText(valueProperty) : getLabelText(styleProperty)}:`;

	return (
		<Button
			className="dragging-value-button"
			size="medium"
			ref={ref}
			variant="text"
			disableRipple
			disableFocusRipple
			startIcon={<>{label}</>}
			onClick={(event) => {
				if (inputMode) {
					return;
				}
				if (!event.isTrusted) {
					inputRef.current?.focus();
					setInputMode(true);
				}
			}}
			onDragStart={(event) => {
				if (inputMode) {
					return;
				}
				event.preventDefault();
			}}
			onMouseDown={(event) => {
				if (inputMode) {
					return;
				}
				event.preventDefault();
				setIsDragging(true);
				handleMouseActionSelectInput(
					ref.current,
					event,
					valueProperty ? valueProperty : styleProperty,
					(updatedValue: number) => {
						handleLocationAttributeChange(updatedValue, styleProperty, valueProperty);
					}
				);
			}}
			onMouseMove={e => {
				if (inputMode) {
					return;
				}
				handleOnMouseMove?.(e);
			}}
			onMouseUp={(e) => {
				if (inputMode) {
					return;
				}
				setIsDragging(false);
				handleOnMouseUp?.(e);
			}}
		>
			<input
				ref={inputRef}
				className={isDragging ? 'value-label' : inputMode ? 'input-mode' : ''}
				type="number"
				value={roundedValue}
				readOnly={isDragging}
				onChange={(event) => {
					if (!inputMode) {
						return;
					}
					valueProperty &&
						handleLocationAttributeChange(Number(event.target.value), styleProperty, valueProperty);
					!valueProperty && handleLocationAttributeChange(Number(event.target.value), styleProperty);
				}}
				onKeyDown={(event) => {
					if (!inputMode) {
						return;
					}
					if (event.keyCode === 13 || event.key === 'Enter') {
						setInputMode(false);
					}
				}}
				onBlur={() => {
					if (!inputMode) {
						return;
					}
					setInputMode(false);
				}}
			/>
		</Button>
	);
};

export default InputMouseAction;
